export default __webpack_public_path__ + "static/media/montserrat-regular.24785cc0.ttf";